import { render, staticRenderFns } from "./ImotDataNotes.vue?vue&type=template&id=f7fecd54"
import script from "./ImotDataNotes.vue?vue&type=script&lang=js"
export * from "./ImotDataNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports